/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './cart-widget.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '../shared/notification.service';
import * as import7 from '@angular/core/src/di/injector';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '../shared/intl.service';
import * as import11 from '../shared/utils.service';
import * as import12 from './cart.service';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '@angular/router/src/router';
import * as import15 from '@angular/core/src/metadata/view';
import * as import16 from '@angular/core/src/linker/component_factory';
import * as import17 from '../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import18 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import19 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '../shared/number-format.pipe';
import * as import21 from '../shared/intl.pipe';
import * as import22 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import23 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import24 from '@angular/core/src/linker/template_ref';
import * as import25 from '@angular/common/src/directives/ng_class';
import * as import26 from '@angular/common/src/directives/ng_for';
import * as import27 from '@angular/common/src/directives/ng_if';
import * as import28 from '@angular/core/src/security';
export class Wrapper_CartWidgetComponent {
  context:import0.CartWidgetComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any) {
    this.changed = false;
    this.context = new import0.CartWidgetComponent(p0,p1,p2,p3,p4,p5);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_0 = currValue;
    }
  }
  check_labels(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this.changed = true;
      this.context.labels = currValue;
      this._expr_1 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_CartWidgetComponent_Host:import4.RenderComponentType = (null as any);
class _View_CartWidgetComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _NotificationService_0_4:import6.NotificationService;
  _CartWidgetComponent_0_5:Wrapper_CartWidgetComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent_Host0,renderType_CartWidgetComponent_Host,import8.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'cart-widget',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_CartWidgetComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._NotificationService_0_4 = new import6.NotificationService(new import9.ElementRef(this._el_0),this.renderer);
    this._CartWidgetComponent_0_5 = new Wrapper_CartWidgetComponent(this._NotificationService_0_4,this.parentInjector.get(import10.IntlService),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import12.CartService),this.parentInjector.get(import13.ActivatedRoute),this.parentInjector.get(import14.Router));
    this._appEl_0.initComponent(this._CartWidgetComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._CartWidgetComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.NotificationService) && (0 === requestNodeIndex))) { return this._NotificationService_0_4; }
    if (((token === import0.CartWidgetComponent) && (0 === requestNodeIndex))) { return this._CartWidgetComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._CartWidgetComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._CartWidgetComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartWidgetComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_CartWidgetComponent_Host === (null as any))) { (renderType_CartWidgetComponent_Host = viewUtils.createRenderComponentType('',0,import15.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_CartWidgetComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const CartWidgetComponentNgFactory:import16.ComponentFactory<import0.CartWidgetComponent> = new import16.ComponentFactory<import0.CartWidgetComponent>('cart-widget',viewFactory_CartWidgetComponent_Host0,import0.CartWidgetComponent);
const styles_CartWidgetComponent:any[] = ([] as any[]);
var renderType_CartWidgetComponent:import4.RenderComponentType = (null as any);
class _View_CartWidgetComponent0 extends import3.AppView<import0.CartWidgetComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _NgClass_5_3:import17.Wrapper_NgClass;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _anchor_19:any;
  /*private*/ _appEl_19:import5.AppElement;
  _TemplateRef_19_5:any;
  _NgFor_19_6:import18.Wrapper_NgFor;
  _text_20:any;
  _text_21:any;
  _anchor_22:any;
  /*private*/ _appEl_22:import5.AppElement;
  _TemplateRef_22_5:any;
  _NgIf_22_6:import19.Wrapper_NgIf;
  _text_23:any;
  _anchor_24:any;
  /*private*/ _appEl_24:import5.AppElement;
  _TemplateRef_24_5:any;
  _NgIf_24_6:import19.Wrapper_NgIf;
  _text_25:any;
  _anchor_26:any;
  /*private*/ _appEl_26:import5.AppElement;
  _TemplateRef_26_5:any;
  _NgIf_26_6:import19.Wrapper_NgIf;
  _text_27:any;
  _anchor_28:any;
  /*private*/ _appEl_28:import5.AppElement;
  _TemplateRef_28_5:any;
  _NgIf_28_6:import19.Wrapper_NgIf;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _map_48:any;
  /*private*/ _expr_49:any;
  _pipe_numberFormat_0:import20.NumberFormat;
  _pipe_intl_1:import21.IntlPipe;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent0,renderType_CartWidgetComponent,import8.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._map_48 = import2.pureProxy1((p0:any):{[key: string]:any} => {
      return {'cart-empty': p0};
    });
    this._expr_49 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import2.createRenderElement(this.renderer,parentRenderNode,'div',new import2.InlineArray2(2,'id','snackbar'),(null as any));
    this._text_1 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,parentRenderNode,'div',new import2.InlineArray2(2,'class','top-cart'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_2,'a',new import2.InlineArray4(4,'class','shopping-cart','href','#'),(null as any));
    this._NgClass_5_3 = new import17.Wrapper_NgClass(this.parentInjector.get(import22.IterableDiffers),this.parentInjector.get(import23.KeyValueDiffers),new import9.ElementRef(this._el_5),this.renderer);
    this._text_6 = this.renderer.createText(this._el_5,' \n        ',(null as any));
    this._el_7 = import2.createRenderElement(this.renderer,this._el_5,'i',new import2.InlineArray2(2,'class','pointer fa fa-shopping-cart'),(null as any));
    this._text_8 = this.renderer.createText(this._el_5,'\n        ',(null as any));
    this._el_9 = import2.createRenderElement(this.renderer,this._el_5,'div',new import2.InlineArray2(2,'class','subtitle'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_5,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_13 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_14 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._el_15 = import2.createRenderElement(this.renderer,this._el_2,'div',new import2.InlineArray2(2,'class','cart-content'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._el_17 = import2.createRenderElement(this.renderer,this._el_15,'ul',new import2.InlineArray2(2,'class','cart-list'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n            ',(null as any));
    this._anchor_19 = this.renderer.createTemplateAnchor(this._el_17,(null as any));
    this._appEl_19 = new import5.AppElement(19,17,this,this._anchor_19);
    this._TemplateRef_19_5 = new import24.TemplateRef_(this._appEl_19,viewFactory_CartWidgetComponent1);
    this._NgFor_19_6 = new import18.Wrapper_NgFor(this._appEl_19.vcRef,this._TemplateRef_19_5,this.parentInjector.get(import22.IterableDiffers),this.ref);
    this._text_20 = this.renderer.createText(this._el_17,'\n        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._anchor_22 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._appEl_22 = new import5.AppElement(22,15,this,this._anchor_22);
    this._TemplateRef_22_5 = new import24.TemplateRef_(this._appEl_22,viewFactory_CartWidgetComponent2);
    this._NgIf_22_6 = new import19.Wrapper_NgIf(this._appEl_22.vcRef,this._TemplateRef_22_5);
    this._text_23 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._anchor_24 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._appEl_24 = new import5.AppElement(24,15,this,this._anchor_24);
    this._TemplateRef_24_5 = new import24.TemplateRef_(this._appEl_24,viewFactory_CartWidgetComponent3);
    this._NgIf_24_6 = new import19.Wrapper_NgIf(this._appEl_24.vcRef,this._TemplateRef_24_5);
    this._text_25 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._anchor_26 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._appEl_26 = new import5.AppElement(26,15,this,this._anchor_26);
    this._TemplateRef_26_5 = new import24.TemplateRef_(this._appEl_26,viewFactory_CartWidgetComponent4);
    this._NgIf_26_6 = new import19.Wrapper_NgIf(this._appEl_26.vcRef,this._TemplateRef_26_5);
    this._text_27 = this.renderer.createText(this._el_15,'\n        ',(null as any));
    this._anchor_28 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._appEl_28 = new import5.AppElement(28,15,this,this._anchor_28);
    this._TemplateRef_28_5 = new import24.TemplateRef_(this._appEl_28,viewFactory_CartWidgetComponent5);
    this._NgIf_28_6 = new import19.Wrapper_NgIf(this._appEl_28.vcRef,this._TemplateRef_28_5);
    this._text_29 = this.renderer.createText(this._el_15,'\n    ',(null as any));
    this._text_30 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_31 = this.renderer.createText(this._el_2,'\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_7,'click',this.eventHandler(this._handle_click_7_0.bind(this)));
    this._pipe_numberFormat_0 = new import20.NumberFormat();
    this._pipe_intl_1 = new import21.IntlPipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._anchor_19,
      this._text_20,
      this._text_21,
      this._anchor_22,
      this._text_23,
      this._anchor_24,
      this._text_25,
      this._anchor_26,
      this._text_27,
      this._anchor_28,
      this._text_29,
      this._text_30,
      this._text_31
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import25.NgClass) && ((5 <= requestNodeIndex) && (requestNodeIndex <= 11)))) { return this._NgClass_5_3.context; }
    if (((token === import24.TemplateRef) && (19 === requestNodeIndex))) { return this._TemplateRef_19_5; }
    if (((token === import26.NgFor) && (19 === requestNodeIndex))) { return this._NgFor_19_6.context; }
    if (((token === import24.TemplateRef) && (22 === requestNodeIndex))) { return this._TemplateRef_22_5; }
    if (((token === import27.NgIf) && (22 === requestNodeIndex))) { return this._NgIf_22_6.context; }
    if (((token === import24.TemplateRef) && (24 === requestNodeIndex))) { return this._TemplateRef_24_5; }
    if (((token === import27.NgIf) && (24 === requestNodeIndex))) { return this._NgIf_24_6.context; }
    if (((token === import24.TemplateRef) && (26 === requestNodeIndex))) { return this._TemplateRef_26_5; }
    if (((token === import27.NgIf) && (26 === requestNodeIndex))) { return this._NgIf_26_6.context; }
    if (((token === import24.TemplateRef) && (28 === requestNodeIndex))) { return this._TemplateRef_28_5; }
    if (((token === import27.NgIf) && (28 === requestNodeIndex))) { return this._NgIf_28_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_5_0_0:any = 'shopping-cart';
    this._NgClass_5_3.check_klass(currVal_5_0_0,throwOnChange,false);
    const currVal_5_0_1:any = this._map_48((this.context.cartService.count() == 0));
    this._NgClass_5_3.check_ngClass(currVal_5_0_1,throwOnChange,false);
    this._NgClass_5_3.detectChangesInInputProps(this,this._el_5,throwOnChange);
    const currVal_19_0_0:any = this.context.cartService.itemsLimited();
    this._NgFor_19_6.check_ngForOf(currVal_19_0_0,throwOnChange,false);
    this._NgFor_19_6.detectChangesInInputProps(this,this._anchor_19,throwOnChange);
    const currVal_22_0_0:any = (this.context.cartService.count() > this.context.cartService.limit);
    this._NgIf_22_6.check_ngIf(currVal_22_0_0,throwOnChange,false);
    this._NgIf_22_6.detectChangesInInputProps(this,this._anchor_22,throwOnChange);
    const currVal_24_0_0:any = (this.context.cartService.count() > 0);
    this._NgIf_24_6.check_ngIf(currVal_24_0_0,throwOnChange,false);
    this._NgIf_24_6.detectChangesInInputProps(this,this._anchor_24,throwOnChange);
    const currVal_26_0_0:any = (this.context.cartService.count() == 0);
    this._NgIf_26_6.check_ngIf(currVal_26_0_0,throwOnChange,false);
    this._NgIf_26_6.detectChangesInInputProps(this,this._anchor_26,throwOnChange);
    const currVal_28_0_0:any = (this.context.cartService.count() > 0);
    this._NgIf_28_6.check_ngIf(currVal_28_0_0,throwOnChange,false);
    this._NgIf_28_6.detectChangesInInputProps(this,this._anchor_28,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgClass_5_3.detectChangesInHostProps(this,this._el_5,throwOnChange);
    const currVal_49:any = import2.interpolate(1,'(',this.context.cartService.count(),')');
    if (import2.checkBinding(throwOnChange,this._expr_49,currVal_49)) {
      this.renderer.setText(this._text_10,currVal_49);
      this._expr_49 = currVal_49;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_7_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_7_0:any = ((<any>this.context.utils.lLink('cart',this.context.language)) !== false);
    return (true && pd_7_0);
  }
}
export function viewFactory_CartWidgetComponent0(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<import0.CartWidgetComponent> {
  if ((renderType_CartWidgetComponent === (null as any))) { (renderType_CartWidgetComponent = viewUtils.createRenderComponentType('',0,import15.ViewEncapsulation.None,styles_CartWidgetComponent,{})); }
  return new _View_CartWidgetComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_CartWidgetComponent1 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  /*private*/ _expr_19:any;
  _pipe_numberFormat_0_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent1,renderType_CartWidgetComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_17 = import1.UNINITIALIZED;
    this._expr_18 = import1.UNINITIALIZED;
    this._expr_19 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'li',import2.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray4(4,'class','remove pointer','title','Remove item'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'×',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_5 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'class','pointer'),(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'\n                    ',(null as any));
    this._el_7 = import2.createRenderElement(this.renderer,this._el_5,'img',new import2.InlineArray8(6,'alt','','height','90','width','90'),(null as any));
    this._text_8 = this.renderer.createText(this._el_5,'\n                    ',(null as any));
    this._text_9 = this.renderer.createText(this._el_5,'\n                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_11 = import2.createRenderElement(this.renderer,this._el_0,'span',new import2.InlineArray2(2,'class','quantity'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._el_13 = import2.createRenderElement(this.renderer,this._el_11,'span',new import2.InlineArray2(2,'class','amount'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_5,'click',this.eventHandler(this._handle_click_5_0.bind(this)));
    this._pipe_numberFormat_0_0 = import2.pureProxy2((<_View_CartWidgetComponent0>this.parent)._pipe_numberFormat_0.transform.bind((<_View_CartWidgetComponent0>this.parent)._pipe_numberFormat_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ,[
      disposable_0,
      disposable_1
    ]
    ,([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_17:any = import2.interpolate(1,'/data/covers/thumbs/',this.context.$implicit.content.cover.front,'');
    if (import2.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_7,'src',this.viewUtils.sanitizer.sanitize(import28.SecurityContext.URL,currVal_17));
      this._expr_17 = currVal_17;
    }
    const currVal_18:any = import2.interpolate(1,'',this.context.$implicit.qty,' × ');
    if (import2.checkBinding(throwOnChange,this._expr_18,currVal_18)) {
      this.renderer.setText(this._text_12,currVal_18);
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_19:any = import2.interpolate(1,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_numberFormat_0_0,(<_View_CartWidgetComponent0>this.parent)._pipe_numberFormat_0.transform)(this.context.$implicit.content.price,2)),'€');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_19,currVal_19))) {
      this.renderer.setText(this._text_14,currVal_19);
      this._expr_19 = currVal_19;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.context.removeFromCart(this.context.$implicit.content._id)) !== false);
    return (true && pd_2_0);
  }
  private _handle_click_5_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_5_0:any = ((<any>this.parent.context.utils.lLink(this.context.$implicit.content.url,this.parent.context.language)) !== false);
    return (true && pd_5_0);
  }
}
function viewFactory_CartWidgetComponent1(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_CartWidgetComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_CartWidgetComponent2 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_intl_1_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent2,renderType_CartWidgetComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'p',new import2.InlineArray2(2,'class','text-center'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'class','pointer gray-text'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this._pipe_intl_1_0 = import2.pureProxy2((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform.bind((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_5:any = import2.interpolate(2,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_0,(<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.SHOW_ALL),this.parent.context.language)),' (',this.parent.context.cartService.count(),')');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.context.utils.lLink('cart',this.parent.context.language)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_CartWidgetComponent2(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_CartWidgetComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_CartWidgetComponent3 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_intl_1_1:any;
  /*private*/ _expr_6:any;
  _pipe_numberFormat_0_1:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent3,renderType_CartWidgetComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import1.UNINITIALIZED;
    this._expr_6 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'p',new import2.InlineArray2(2,'class','total'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'span',new import2.InlineArray2(2,'class','amount'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_intl_1_1 = import2.pureProxy2((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform.bind((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1));
    this._pipe_numberFormat_0_1 = import2.pureProxy2((<_View_CartWidgetComponent0>this.parent)._pipe_numberFormat_0.transform.bind((<_View_CartWidgetComponent0>this.parent)._pipe_numberFormat_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import2.interpolate(1,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_1,(<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.PROPERTY.SUBTOTAL),this.parent.context.language)),': ');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
    valUnwrapper.reset();
    const currVal_6:any = import2.interpolate(1,'\n        ',valUnwrapper.unwrap(import2.castByValue(this._pipe_numberFormat_0_1,(<_View_CartWidgetComponent0>this.parent)._pipe_numberFormat_0.transform)(this.parent.context.cartService.subtotal(),2)),'€');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_6,currVal_6))) {
      this.renderer.setText(this._text_3,currVal_6);
      this._expr_6 = currVal_6;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartWidgetComponent3(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_CartWidgetComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_CartWidgetComponent4 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_intl_1_2:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent4,renderType_CartWidgetComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'p',new import2.InlineArray2(2,'class','total'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_intl_1_2 = import2.pureProxy2((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform.bind((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_2:any = import2.interpolate(1,'',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_2,(<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.EMPTY),this.parent.context.language)),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_CartWidgetComponent4(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_CartWidgetComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_CartWidgetComponent5 extends import3.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  /*private*/ _expr_6:any;
  _pipe_intl_1_3:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement) {
    super(_View_CartWidgetComponent5,renderType_CartWidgetComponent,import8.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
    this._expr_6 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.createRenderElement(this.renderer,(null as any),'p',new import2.InlineArray2(2,'class','buttons text-center'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' \n            ',(null as any));
    this._el_2 = import2.createRenderElement(this.renderer,this._el_0,'a',new import2.InlineArray2(2,'class','pointer btn btn-very-small-white no-margin-bottom margin-seven no-margin-lr'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this._pipe_intl_1_3 = import2.pureProxy2((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform.bind((<_View_CartWidgetComponent0>this.parent)._pipe_intl_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_6:any = import2.interpolate(1,'\n                    ',valUnwrapper.unwrap(import2.castByValue(this._pipe_intl_1_3,(<_View_CartWidgetComponent0>this.parent)._pipe_intl_1.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.CART.GO),this.parent.context.language)),'');
    if ((valUnwrapper.hasWrappedValue || import2.checkBinding(throwOnChange,this._expr_6,currVal_6))) {
      this.renderer.setText(this._text_3,currVal_6);
      this._expr_6 = currVal_6;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.context.utils.lLink('cart',this.parent.context.language)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_CartWidgetComponent5(viewUtils:import2.ViewUtils,parentInjector:import7.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  return new _View_CartWidgetComponent5(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cart-widget.component.ngfactory.ts